import styled from "styled-components";
import { Divider, WaitingButton } from "@evergis/ui";
import { SnappingMapControl } from "../MapControls/components/Snapping/styled";

export const PrintMapControl = styled(SnappingMapControl)`
  height: auto;
`;

export const PrintWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1rem;
  box-sizing: border-box;
`;

export const PrintHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 1.5rem;
`;

export const PrintHeaderTitle = styled.div`
  font-size: 20px;
  color: white;
  opacity: 0.85;
  margin-right: auto;
`;

export const PrintHeaderActionsDivider = styled(Divider)`
  margin-right: 0.5rem;
  margin-left: 0.5rem;
`;

export const PrintContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PrintSettingsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const GridSettingContainer = styled.div`
  align-items: flex-end;
  display: flex;
  margin: 0 0 0.8rem 0;
`;

export const ColorMargin = styled.span`
  margin-left: 1rem;
`;

export const LegendDropdownContainer = styled.div`
  margin-bottom: 1rem;
`;

export const PrintActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: left;
  justify-content: flex-end;
  padding-top: 1.0625rem;
`;

export const PrintButton = styled(WaitingButton)`
  margin-left: 1rem;
`;
